// Separate from the action journal: cached reads may be replaced; pending writes may not.
let opening;
const open = () => {
  if (!opening) opening = new Promise((resolve, reject) => {
    const request = indexedDB.open('drwaiting-dashboard-offline-v1', 2);
    request.onupgradeneeded = () => {
      for (const name of ['responses', 'patients', 'waiting', 'files', 'profileActions', 'revisions']) {
        if (!request.result.objectStoreNames.contains(name)) request.result.createObjectStore(name, { keyPath: 'key' });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => { opening = undefined; reject(new Error('Offline storage is unavailable.')); };
    request.onblocked = () => { opening = undefined; reject(new Error('Close older dashboard tabs and retry.')); };
  });
  return opening;
};
export async function localTransaction(name, mode, operation) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(name, mode);
    const request = operation(transaction.objectStore(name));
    transaction.oncomplete = () => resolve(request.result);
    transaction.onabort = () => reject(new Error('Device storage is full or unavailable. Nothing was confirmed saved.'));
    transaction.onerror = () => {};
  });
}
export const localStore = {
  get: (name, key) => localTransaction(name, 'readonly', store => store.get(key)),
  put: (name, value) => localTransaction(name, 'readwrite', store => store.put(value)),
  remove: (name, key) => localTransaction(name, 'readwrite', store => store.delete(key)),
  list: name => localTransaction(name, 'readonly', store => store.getAll()),
};
